import apiHttpClient from "./ApiHttpService";

export default class FileService {
  getManualUrl(lang) {
    return apiHttpClient.get(`trs/mobile/file/getManualUrl/${lang}`);
  }
}

